import { useContext, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { SectionContext } from '../../context/SectionContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorSectionFormatter = ({
  section
}) => {
  const {
    metricsFactory
  } = useContext(SectionContext);
  const sectionType = section.__typename;
  useEffect(() => {
    if (metricsFactory) {
      metricsFactory.counter('error_section_rendered', {
        sectionType
      }).increment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "errors/general",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "chatspotComponents.sections.errorSectionTitle"
    })
  });
};
export default ErrorSectionFormatter;